module.exports = __webpack_public_path__ + "static/media/wismon.45fa089c.png";